var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dash-button',{staticClass:"button-export",attrs:{"label":"Export","prefix":"export-csv"},on:{"click":_vm.openCsvExportModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }